<template>
	<a-dropdown :trigger="['click']" placement="bottomLeft">
		<div :class="$style.dropdown">
			<a-avatar shape="square" :src="images().avatar(user)" size="large" :class="$style.avatar" @error="onAvatarError">
				<template #icon>
					<a-icon type="user" />
				</template>
			</a-avatar>
		</div>
		<template #overlay>
			<a-menu v-if="user">
				<a-menu-item>
					<strong>Hola, {{ user.username }}</strong>
					<div>
						<strong>Rol:</strong>
						{{ role }}
					</div>
				</a-menu-item>
				<a-menu-divider />
				<a-menu-item>
					<router-link :to="{name: 'user', params: {id: user.id }}">
						<i :class="$style.menuIcon" class="fe fe-user" /> Editar perfil
					</router-link>
				</a-menu-item>
				<a-menu-item>
					<a @click="cleanCache">
						<i :class="$style.menuIcon" class="fe fe-feather" /> Limpiar Cache
					</a>
				</a-menu-item>
				<a-menu-item>
					<a @click="toggleSidebar()">
						<i :class="$style.menuIcon" class="fe fe-loader" /> Personalización
					</a>
				</a-menu-item>
				<a-menu-item>
					<a href="javascript: void(0);" @click="logout">
						<i :class="$style.menuIcon" class="fe fe-log-out" /> Salir
					</a>
				</a-menu-item>
			</a-menu>
		</template>
	</a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {

		};
	},
	computed: {
		...mapGetters(['user', 'settings', 'role']),
	},
	methods: {
		onAvatarError(e) { if (e && e.target) e.target.src = require('../../../../assets/img/placeholder/avatar.jpg'); return false; },
		cleanCache() {
			this.$store.commit('CLEAR_ALL_DATA');
			this.$store.commit('RESET_ALL_FILTERS');
			this.$store.commit('RESET_FLAGS');
			this.$store.commit('REMOVE_ALL_FORMS');
			this.$store.commit('CLEAR_ALL_STATS');

			window.location.reload();
		},
		logout() {
			this.$store.dispatch('logout');
		},
		toggleSidebar() {
			this.$store.commit('CHANGE_SETTING', { setting: 'isSidebarOpen', value: true });
		},
	},
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
